import { render, staticRenderFns } from "./VFieldPhone.vue?vue&type=template&id=07ec4596&"
import script from "./VFieldPhone.vue?vue&type=script&lang=js&"
export * from "./VFieldPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ec4596')) {
      api.createRecord('07ec4596', component.options)
    } else {
      api.reload('07ec4596', component.options)
    }
    module.hot.accept("./VFieldPhone.vue?vue&type=template&id=07ec4596&", function () {
      api.rerender('07ec4596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VFieldPhone.vue"
export default component.exports